import { request } from '@/lib/api';
export const defaultPosterStyles = [
  {
    value: 'default',
    label: 'Style',
    description: 'Standard poster style with balanced elements',
    previewImage:
      'https://static.seedeai.com/templates/94a71dc9-333f-40a5-8ced-527be35e14e2_thumbnail.webp?v=1',
  },
  {
    value: 'lightshadow',
    label: 'Light & Shadow',
    description:
      'featuring a light and shadow design style with a focus on subtle textures and soft lighting.',
    previewImage:
      'https://static.seedeai.com/templates/c212810f-8e2f-4f30-8146-ab01f94de7e1_thumbnail.webp?v=1',
  },
  {
    value: 'gradient',
    label: 'Gradient Flow',
    description:
      'Smooth flowing gradients with vibrant color transitions creating a modern and dynamic visual experience.',
    previewImage:
      'https://static.seedeai.com/templates/1112610f-281a-4272-acd4-d1df01f13bf0_thumbnail.webp?v=1',
  },
  {
    value: 'vintage',
    label: 'Vintage Retro',
    description:
      'Nostalgic design with retro typography, muted colors, and textured backgrounds reminiscent of classic poster art.',
    previewImage:
      'https://static.seedeai.com/templates/f45e4f6d-42b9-4411-8e77-07edfc0c20ba_thumbnail.webp?v=1',
  },
  {
    value: 'geometric',
    label: 'Geometric Abstract',
    description:
      'Bold geometric shapes and patterns creating visual interest with strong lines and structured composition.',
    previewImage:
      'https://static.seedeai.com/templates/79189b69-5ae6-49fa-b569-1a3fc57840b0_thumbnail.webp?v=1',
  },
  {
    value: 'neon',
    label: 'Neon Glow',
    description:
      'Vibrant neon colors against dark backgrounds with glowing effects creating an energetic nightlife atmosphere.',
    previewImage:
      'https://static.seedeai.com/templates/1a742b1b-985c-4e21-aa41-a1d08080f347_thumbnail.webp?v=1',
  },
  {
    value: 'organic',
    label: 'Organic Nature',
    description:
      'Natural elements and flowing organic shapes with earthy color palettes inspired by the natural world.',
    previewImage:
      'https://static.seedeai.com/templates/4c6dfcc1-650d-41d5-94ac-5538927fdd7f_thumbnail.webp?v=1',
  },
  {
    value: 'typographic',
    label: 'Typography Focus',
    description:
      'Design centered around creative typography arrangements with minimal imagery and strong font hierarchy.',
    previewImage:
      'https://static.seedeai.com/templates/abb7ab46-cccb-4f63-92bc-deae5b15a759_thumbnail.webp?v=1',
  },
  {
    value: 'isometric',
    label: 'Isometric 3D',
    description:
      'Three-dimensional isometric illustrations with geometric shapes and vibrant colors creating playful and modern visuals',
    previewImage:
      'https://static.seedeai.com/templates/9a202b47-1d76-42a4-a2e5-ca042d527ccf_thumbnail.webp?v=1',
  },
  {
    value: 'minimalist',
    label: 'Minimalist',
    description: 'Clean, simple design with ample white space',
    previewImage:
      'https://static.seedeai.com/templates/12fec694-ddb8-4aba-9cc9-443f92bf5e5c_thumbnail.webp?v=1',
  },
  {
    value: 'service',
    label: 'Service Oriented',
    description:
      'Friendly and approachable design highlighting customer service values with warm colors and inviting imagery',
    previewImage:
      'https://static.seedeai.com/templates/03bed5ca-5557-4836-8ae1-26a5cc3a6ee5_thumbnail.webp?v=1',
  },
  {
    value: 'beauty',
    label: 'Beauty & Cosmetics',
    description:
      'Elegant and glamorous style with soft tones, luxurious textures, and sophisticated typography for beauty products',
    previewImage:
      'https://static.seedeai.com/templates/20acc370-fb4b-46b1-a90b-1aac1e89674d_thumbnail.webp?v=1',
  },
  {
    value: 'lifestyle',
    label: 'Lifestyle & Wellness',
    description:
      'Balanced and harmonious design with calming colors and clean layouts promoting wellbeing and healthy living',
    previewImage:
      'https://static.seedeai.com/templates/dc59748a-ee24-4faa-bd7d-77f9fb672b1d_thumbnail.webp?v=1',
  },
  {
    value: 'fashion',
    label: 'Fashion Forward',
    description:
      'Trendy and stylish design with bold typography and high-contrast elements perfect for fashion campaigns',
    previewImage:
      'https://static.seedeai.com/templates/074f36de-6fb4-4929-a9fa-f9588a230322_thumbnail.webp?v=1',
  },
  {
    value: 'glassmorphism',
    label: 'Glass Morphism',
    description:
      'Modern frosted glass effect with blurred backgrounds and semi-transparent layers creating depth and dimension',
    previewImage:
      'https://static.seedeai.com/templates/59f19c33-67af-43e3-86ce-8fff5493020a_thumbnail.webp?v=1',
  },
  {
    value: 'brutalism',
    label: 'Digital Brutalism',
    description:
      'Raw, unpolished aesthetic with bold typography, stark contrasts, and unconventional layouts for edgy digital designs',
    previewImage:
      'https://static.seedeai.com/templates/cdc9409f-f199-4144-b043-c2c99f10acfb_thumbnail.webp?v=1',
  },
];

const styles = [
  {
    value: 'default',
    label: '海报风格',
    previewImage:
      'https://static.seedeai.com/templates/94a71dc9-333f-40a5-8ced-527be35e14e2_thumbnail.webp?v=1',
  },
  {
    value: 'luxury-natural-ambiance',
    label: '奢华自然意境风',
    previewImage:
      'https://static.seedeai.com/templates/e7821052-4123-4d04-8722-d8c81a65ac08_thumbnail.webp?v=1',
    prompt: `# 奢华自然意境风

## 设计风格

- **高级沉稳色调**：暗调景观背景配以细腻光影，营造高端内敛氛围
- **意境式呈现**：不仅展示实景，更表达一种与自然共融的精神状态
- **奢华隐喻元素**：通过构图和文字暗示高端生活方式与品质追求
- **空间层次丰富**：通过前景、中景、远景的搭配创造空间深度感
- **东西方美学融合**：中式意境与西方现代摄影美学的和谐结合
- **沉浸式体验设计**：画面设计引导观者产生身临其境的感受

## 文字排版风格

- **悬浮式标题定位**：文字悬浮于景观之上，形成虚实对比
- **中西文混合排版**：英文与中文标题组合使用，增强国际化气质
- **层级分明的字阶**：主标题、副标题和说明文字尺寸差异明显
- **优雅字体选择**：英文多用细腻的衬线体，中文选用简约现代字体
- **巧妙的文字拆分**：文字的艺术性拆解处理
- **留白与文字平衡**：大面积留白中点缀核心文字，强化重点信息
- **边缘式辅助信息**：次要文字信息常放置于画面边缘，不干扰主视觉

## 视觉元素风格

- **摄影级光影处理**：专业摄影级别的光线捕捉，展现自然光影魅力
- **景深虚化技巧**：背景适度虚化，突出主体，增强画面层次感
- **半透明叠加处理**：文字与背景间常有微妙的半透明效果
- **隐性品牌符号**：品牌元素融入自然场景，不刻意张扬
- **导航指示符号**：左右导航箭头简洁统一，融入整体设计
- **水墨意境渲染**：部分元素带有东方水墨画的意境处理
- **大气构图法则**：遵循三分法或黄金分割构图，画面大气平衡`,
  },
  {
    value: 'flowing-tech-blue',
    label: '流动科技蓝风格',
    previewImage:
      'https://static.seedeai.com/templates/8dce217f-270a-4657-9fb5-fe6406d995f9_thumbnail.webp?v=1',
    prompt: `# 流动科技蓝风格

## 设计风格

- 现代简约科技风，以蓝色系为主体色调
- 大量使用蓝白渐变，营造轻盈通透感
- 背景多采用极简白底或浅色调
- 运用流线型曲线创造动态视觉效果
- 圆角矩形作为基础框架，增加友好感
- 整体布局干净有序，空间感强
- 光影效果柔和，营造科技感与未来感

## 文字排版风格

- 标题简洁有力，通常使用黑体或无衬线字体
- 显著的标题层级对比，主副标题大小分明
- 中英文混排，增加国际化视觉效果
- 关键信息放大处理，辅助文字精简
- 日期、标签等信息排版整齐规范
- 文字与背景形成适当对比，确保清晰可读
- 数字与文本搭配得当，注重整体平衡

## 视觉元素风格

- 流动曲线是主要装饰元素，表现科技流动感
- 半透明蓝色波纹或螺旋形状贯穿多个设计
- 几何抽象形状作为点缀（圆环、三角形等）
- 轻量级图标和按钮设计，简洁明了
- 折纸元素（如纸飞机）象征传递与连接
- 光效处理柔和，形成层次感
- 整体视觉元素与科技、数据、信息等主题高度契合
`,
  },
  {
    value: 'minimalist-grid-cover',
    label: '极简格栅主义封面风格',
    previewImage:
      'https://static.seedeai.com/templates/a872921d-5732-4371-b44f-1cb5105fd13a_thumbnail.webp?v=2',
    prompt: `# 极简格栅主义封面风格

## 设计风格

- **黑白极简风格**：以纯黑背景和纯白内容区形成鲜明对比
- **强烈的几何感**：使用简洁的线条、方框和圆形等基础几何元素
- **网格系统布局**：遵循严格的网格排版规则，结构清晰有序
- **留白有度**：大量留白创造呼吸感，同时保持视觉重心
- **摄影与排版结合**：真实场景照片与极简排版形成互补
- **工业风格装饰**：细线箭头、指示线条等元素增添设计感
- **微妙的色彩点缀**：小面积绿色等强调色打破黑白单调

## 文字排版风格

- **大胆字号对比**：核心标题极大化处理，形成主视觉
- **几何式分割标题**：将主标题分解成独立区块，增强辨识度
- **纵横组合排版**：文字既有横排也有竖排，创造韵律感
- **字体粗细对比强烈**：主标题采用超黑体，副文本则较为轻盈
- **多层级信息排列**：活动名称、日期、宣传语清晰分级
- **严格的文字对齐**：所有文字元素依循严格的网格对齐原则
- **中英文混排**：英文作为装饰性元素增添国际设计感

## 视觉元素风格

- **裁切的摄影图像**：图片经过精心裁切，凸显主题
- **指示性线条**：箭头、曲线和直线作为引导性视觉元素
- **框架式强调**：使用方框、底色块等元素强调关键信息
- **简洁图形符号**：最小化的视觉符号传达核心信息
- **构图对称与不对称并存**：整体结构有序但细节处理不拘一格
- **空间层次感**：通过元素大小、位置创造前后层次关系
- **数字图形化处理**：日期数字被赋予视觉设计感`,
  },
];

export async function getRemoteScenes() {
  const scenes = await request('/scene');
  return scenes;
}

export async function getProductScenes() {
  return [...products];
}

export async function getProductScenesAlpha() {
  const remotes = await getRemoteScenes();
  return [...remotes];
}

export const products = [
  {
    name: 'scrollytelling-generator',
    tag: 'scrollytelling',
    type: 'main',
    title: 'products.scrollytellingGenerator.title',
    nameText: 'products.scrollytellingGenerator.name',
    description: 'products.scrollytellingGenerator.description',
    systemPrompt: '{{seede-scene-scrollytelling-generator}}',
    isHot: true,
    image:
      'https://static.seedeai.com/templates/2d29ce08-a7c6-4d4e-a433-fed3d7765e15_thumbnail.webp?v=1',
    listLayout: 'col',
    size: {
      w: 1080,
      h: 3688,
    },
  },
  {
    name: 'poster-generator',
    tag: 'poster',
    type: 'main',
    listLayout: 'col',
    title: 'products.posterGenerator.title',
    nameText: 'products.posterGenerator.name',
    description: 'products.posterGenerator.description',
    systemPrompt: '{{seede-scene-poster-generator}}',
    image:
      'https://static.seedeai.com/templates/a9d42a80-244e-4482-b5c5-5428105eaf0a_thumbnail.webp?v=1',
    bgColor: 'bg-gradient-to-r from-blue-100 to-purple-100',
    size: {
      w: 1080,
      h: 1920,
    },
  },
  {
    name: 'social-media-generator',
    tag: 'social-media',
    type: 'main',
    title: 'products.socialMediaGenerator.title',
    nameText: 'products.socialMediaGenerator.name',
    description: 'products.socialMediaGenerator.description',
    systemPrompt: '{{seede-scene-social-media-generator}}',
    image:
      'https://static.seedeai.com/templates/b5faa2cc-2519-4050-b76f-14aa948b80c0_thumbnail.webp?v=1',

    bgColor: 'bg-gradient-to-r from-indigo-100 to-violet-100',
    size: {
      w: 1080,
      h: 1440,
    },
    styles,
  },
  {
    name: 'presentation-generator',
    tag: 'presentation',
    title: 'products.presentationGenerator.title',
    nameText: 'products.presentationGenerator.name',
    description: 'products.presentationGenerator.description',
    systemPrompt: '{{seede-scene-presentation-generator}}',
    disableBatchMode: true,
    image:
      'https://static.seedeai.com/templates/227a997b-5149-4349-a5e7-392a2cd9df23_thumbnail.webp?v=1',
    listLayout: 'smcol',
    size: {
      value: '16:9',
      w: 1280,
      h: 720,
    },
  },
  {
    name: 'multi-page-brochure-generator',
    tag: 'brochure',
    disableBatchMode: true,
    title: 'products.multiPageBrochureGenerator.title',
    nameText: 'products.multiPageBrochureGenerator.name',
    description: 'products.multiPageBrochureGenerator.description',
    systemPrompt: '{{seede-scene-multi-page-brochure-generator}}',
    image:
      'https://static.seedeai.com/templates/6ce5d2f8-360c-4229-a467-33dd26e9b3de_thumbnail.webp?v=1',
    listLayout: 'col',
    size: {
      w: 1527,
      h: 1080,
      value: 'a4h',
    },
  },
  {
    name: 'diagram-generator',
    tag: 'diagram',
    title: 'products.diagramGenerator.title',
    nameText: 'products.diagramGenerator.name',
    description: 'products.diagramGenerator.description',
    systemPrompt: '{{seede-scene-diagram-generator}}',
    isNew2: true,
    artifactMode: 'svg',
    image:
      'https://static.seedeai.com/templates/47b4b18a-2385-409d-86c4-54638be4ee68_thumbnail.webp?v=1',
    listLayout: 'smcol',
    size: {
      w: 1200,
      h: 800,
    },
  },

  {
    name: 'ai-pull-up-banner-generator',
    tag: 'pull-up-banner',
    title: 'products.pullUpBanner.title',
    nameText: 'products.pullUpBanner.name',
    description: 'products.pullUpBanner.description',
    systemPrompt: '{{seede-scene-ai-pull-up-banner-generator}}',
    image:
      'https://static.seedeai.com/templates/bcff6ee5-dea0-4481-b175-cb8604ea76ec_thumbnail.webp?v=1',
    listLayout: 'smcol',
    size: {
      value: 'pullUpBanner',
      w: 800,
      h: 2000,
    },
  },

  {
    name: 'ai-flyer-generator',
    tag: 'flyer',
    title: 'products.flyerGenerator.title',
    nameText: 'products.flyerGenerator.name',
    description: 'products.flyerGenerator.description',
    systemPrompt: '{{seede-scene-ai-flyer-generator}}',
    image:
      'https://static.seedeai.com/templates/1414f808-4d7a-4bf2-a4d0-df49667ef319_thumbnail.webp?v=2',
    listLayout: 'smcol',
    size: {
      value: 'a4',
      w: 1080,
      h: 1527,
    },
  },

  {
    name: 'menu-generator',
    tag: 'menu',
    title: 'products.menuGenerator.title',
    nameText: 'products.menuGenerator.name',
    description: 'products.menuGenerator.description',
    systemPrompt: '{{seede-scene-menu-generator}}',
    image:
      'https://static.seedeai.com/templates/23c0e9f9-8514-4e0c-9529-261ff4930880_thumbnail.webp?v=1',
    bgColor: 'bg-gradient-to-r from-amber-100 to-orange-100',
    listLayout: 'col',
    size: {
      w: 1080,
      h: 1920,
    },
    styles,
  },
  {
    name: 'music-album-generator',
    tag: 'Album cover',
    title: 'products.albumCoverGenerator.title',
    nameText: 'products.albumCoverGenerator.name',
    description: 'products.albumCoverGenerator.description',
    systemPrompt: '{{seede-scene-music-album-generator}}',
    image:
      'https://static.seedeai.com/templates/9cb9b217-a7d7-4cfd-a19f-efaf9d15fb10_thumbnail.webp?v=1',
    bgColor: 'bg-gradient-to-r from-blue-100 to-cyan-100',
    listLayout: 'smcol',
    size: {
      w: 1080,
      h: 1080,
    },
  },

  {
    name: 'infographic-generator',
    tag: 'infographic',
    title: 'products.infographicGenerator.title',
    nameText: 'products.infographicGenerator.name',
    description: 'products.infographicGenerator.description',
    systemPrompt: '{{seede-scene-infographic-generator}}',
    image:
      'https://static.seedeai.com/templates/0e70dca3-fc21-4c1d-94c3-42998bb48dfb_thumbnail.webp?v=1',
    bgColor: 'bg-gradient-to-r from-green-100 to-teal-100',
    listLayout: 'col',
    size: {
      w: 1080,
      h: 1920,
    },
  },

  {
    name: 'wechat-cover-generator',
    tag: 'wechat-cover',
    title: 'products.wechatCoverGenerator.title',
    nameText: 'products.wechatCoverGenerator.name',
    description: 'products.wechatCoverGenerator.description',
    systemPrompt: '{{seede-scene-wechat-cover-generator}}',
    image:
      'https://static.seedeai.com/templates/26d89faa-c25b-4074-816d-f7cefd0cacbc_thumbnail.webp?v=1',
    bgColor: 'bg-gradient-to-r from-emerald-100 to-teal-100',
    listLayout: 'smcol',
    size: {
      w: 900,
      h: 383,
    },
    styles,
  },
  {
    name: 'invitation-generator',
    tag: 'invitation',
    title: 'products.invitationGenerator.title',
    nameText: 'products.invitationGenerator.name',
    description: 'products.invitationGenerator.description',
    systemPrompt: '{{seede-scene-invitation-generator}}',
    image:
      'https://static.seedeai.com/templates/3919521b-1f5a-48e4-b677-716621a889eb_thumbnail.webp?v=1',
    bgColor: 'bg-gradient-to-r from-pink-100 to-orange-100',
    size: {
      w: 1080,
      h: 1920,
    },
  },
  {
    name: 'signage-generator',
    tag: 'signage',
    title: 'products.signageGenerator.title',
    nameText: 'products.signageGenerator.name',
    description: 'products.signageGenerator.description',
    systemPrompt: '{{seede-scene-signage-generator}}',
    image:
      'https://static.seedeai.com/templates/9aeadea9-e4d9-4c50-a7a4-c318ff811606_thumbnail.webp?v=1',
    bgColor: 'bg-gradient-to-r from-blue-100 to-cyan-100',
    listLayout: 'smcol',
    size: {
      w: 1080,
      h: 1527,
      value: 'a4',
    },
  },

  {
    name: 'flash-card-generator',
    title: 'products.flashcardGenerator.title',
    nameText: 'products.flashcardGenerator.name',
    description: 'products.flashcardGenerator.description',
    systemPrompt: '{{seede-scene-flash-card-generator}}',
    visibility: 'hidden',
    image:
      'https://static.seedeai.com/templates/c4cbd9d7-b55e-40d4-b58d-f922bf83fcb6_thumbnail.webp?v=1',
    bgColor: 'bg-gradient-to-r from-yellow-100 to-amber-100',
    size: {
      w: 1080,
      h: 1440,
    },
  },
  {
    name: 'raw-generator',
    title: 'products.flashcardGenerator.title',
    nameText: 'products.flashcardGenerator.name',
    description: 'products.flashcardGenerator.description',
    systemPrompt: '{{seede-scene-raw-generator}}',
    styles: [],
    visibility: 'hidden',
    image:
      'https://static.seedeai.com/templates/b30b2893-48f0-4a3c-818a-1de47463df9b_thumbnail.webp?v=1',
    bgColor: 'bg-gradient-to-r from-yellow-100 to-amber-100',
    size: {
      w: 1080,
      h: 1440,
    },
  },
];
